export const OTP_CODE_LENGTH = 6

export function normalizeOtpCode(value: string): string {
  return value.replace(/[^0-9a-zA-Z]/g, '').toUpperCase()
}
